"use client";
import React from "react";
import Link from "next/link";

const CityTicker = () => {
  const linkedCities = [
    { name: "Brampton", href: "/brampton-appraiser" },
    { name: "Toronto", href: "/toronto-appraiser" },
    { name: "Mississauga", href: "/mississauga-appraiser" },
    { name: "Etobicoke", href: "/etobicoke-appraiser" },
    { name: "Vaughan", href: "/vaughan-appraiser" },
    { name: "Oakville", href: "/oakville-appraiser" },
  ];

  const otherCities = [
   
    "Burlington",
    "Caledon",
    "Downtown Toronto",

    "Milton",
    "Richmond Hill",
    "King City",
    "Georgetown",
    "Across The GTA",
  ];

  return (
    <div className="relative flex max-w-[75vw] sm:max-w-[100%] overflow-x-hidden bg-white dark:bg-zinc-950 border-b border-zinc-800 ">
      <style jsx global>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .scrolling-wrapper {
          animation: scroll 40s linear infinite;
          display: flex;
          white-space: nowrap;
        }

        .scrolling-wrapper:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="py-2 scrolling-wrapper">
        <div className="flex">
          {/* First set */}
          {linkedCities.map((city) => (
            <React.Fragment key={city.name}>
              <Link
                href={city.href}
                className=" text-zinc-400 hover:underline mx-2"
              >
                {city.name}
              </Link>
              <span className="text-blue-700 mx-4">•</span>
            </React.Fragment>
          ))}
          {otherCities.map((city) => (
            <React.Fragment key={city}>
              <span className="text-zinc-400 mx-2 text-blue-400">{city}</span>
              <span className="text-blue-700 mx-2">•</span>
            </React.Fragment>
          ))}

          {/* Second set for seamless loop */}
          {linkedCities.map((city) => (
            <React.Fragment key={`${city.name}-2`}>
              <Link
                href={city.href}
                className="text-blue-400 text-zinc-400 hover:underline transition-colors mx-2"
              >
                {city.name}
              </Link>
              <span className="text-blue-700 mx-4">•</span>
            </React.Fragment>
          ))}
          {otherCities.map((city) => (
            <React.Fragment key={`${city}-2`}>
              <span className="text-zinc-500 mx-2 text-blue-400">{city}</span>
              <span className="text-zinc-700 mx-2">•</span>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CityTicker;
